var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClasses,on:{"click":_vm.onClick}},[_vm._t("leading-icon"),_c('span',{staticClass:"flex items-center"},[_vm._t("default")],2),_vm._t("trailing-icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }